import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "app/reusable/common.service";
import { Subject } from "rxjs";
import { environment } from "environments/environment";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-mid-office-diagnose-list",
  templateUrl: "./mid-office-diagnose-list.component.html",
  styleUrls: ["./mid-office-diagnose-list.component.scss"],
})
export class MidOfficeDiagnoseListComponent implements OnInit, OnDestroy {
  dataSource = [];
  list = [];
  data: any[] = [];
  public deleteDialogOpened = false;
  public detailsDialogOpened = false;
  private _subject$: Subject<boolean> = new Subject();
  public serverUrlSlot3 : string = environment.Services.AlphaURLSlot3;
  selectedMidOfficeDiagnosesType;

  constructor(
    private CommonService: CommonService,
  ) { }
  showGrid = true;

  ngOnInit() {
    this.getData();
  }

  public getData() {
    let GetMidOfficeDiagnosesUrl: string = `MidOfficeDiagnose/GetAll`;
    this.CommonService.getData(GetMidOfficeDiagnosesUrl, this.serverUrlSlot3).pipe(takeUntil(this._subject$)).subscribe(
      (data: any) => {
        this.dataSource = data;
        this.list=[];
        this.dataSource.forEach((element) => {
          if (element.icdDiagnoses.length == 0) {            
            this.list.push({
              modId: element.modId,
              modCode: element.modCode,
              modType: element.modType,
              modIsActive: element.modIsActive,
            });
          }
          else if (element.icdDiagnoses.length != 0) {
            this.list.push({
                modId: element.modId,
                modCode: element.modCode,
                modType: element.modType,
                modIsActive: element.modIsActive,
                icdName: element.icdNames,
                icdCode: element.icdCodes,
           });
          }
        }); 
        this.data = [...this.list];
        this.detailsDialogOpened = false;
      }
    );
  }

  openDetail() { 
    if(this.selectedMidOfficeDiagnosesType.modId != null)
    this.openDetails(this.selectedMidOfficeDiagnosesType.modId)
    this.selectedMidOfficeDiagnosesType = null; 
  }
 
  onCellClick($event) {
    this.selectedMidOfficeDiagnosesType = $event.dataItem
  }
  public Delete(event) {
    this.deleteDialogOpened = event.DeleteDialogOpened;
    if (event.modId != "") {
      this.data = this.data.filter(
        (e) => e.modId != event.modId
      );
    }
    this.data = [...this.data];
  }

  deleteId;
  openDelete(id): void {
    this.deleteId = id;
    this.deleteDialogOpened = true;
  }

  modId: string;
  openDetails(id: string): void {
    this.modId = id;
    this.detailsDialogOpened = true;
  }

  public save(event) {
    this.detailsDialogOpened = false;
    this.getData();
  }

  public cancel() {
    this.getData();    
  }

  ngOnDestroy() {
    this._subject$.unsubscribe();
  }
}
